import { jsx, jsxs } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ResultsIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: getDefaultHeight(svgProps, 24),
    ...svgProps,
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      stroke: color ?? "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      children: [/*#__PURE__*/jsx("path", {
        d: "M2.25.75h19.5a1.538 1.538 0 011.5 1.5v19.5a1.538 1.538 0 01-1.5 1.5H2.25a1.538 1.538 0 01-1.5-1.5V2.15a1.52 1.52 0 011.5-1.4z"
      }), /*#__PURE__*/jsx("path", {
        d: "M12.05 4.45l-4.5 6-3-3"
      }), /*#__PURE__*/jsx("path", {
        d: "M14.25 8.15h4.6"
      }), /*#__PURE__*/jsx("path", {
        d: "M12.05 13.45l-4.5 6-3-3"
      }), /*#__PURE__*/jsx("path", {
        d: "M14.25 17.15h4.6"
      })]
    })
  });
};

export { ResultsIcon };
//# sourceMappingURL=results.js.map
